/**
 * The schemas of the capabilities a draft names, fetched once each and
 * cached by capability. A capability that is not installed has none, which
 * the inspector says rather than guessing its fields.
 */
import { useQueries } from '@tanstack/react-query';

import { getCapabilitySchema } from '@optum/api-client/endpoints/capabilities';
import type { CapabilitySchema } from '@optum/api-client/types';

import { qk } from '../../lib/query-keys.js';
import type { Schemas } from './references.js';

export function useCapabilitySchemas(ids: readonly string[]): Schemas {
  const unique = [...new Set(ids.filter((id) => id.length > 0))];
  const results = useQueries({
    queries: unique.map((id) => ({
      queryKey: qk.capabilitySchema(id),
      queryFn: () => getCapabilitySchema(id),
      retry: false,
      staleTime: 60_000,
    })),
  });
  const schemas = new Map<string, CapabilitySchema>();
  unique.forEach((id, i) => {
    const data = results[i]?.data;
    if (data) schemas.set(id, data);
  });
  return schemas;
}
